function initAussendienstPopup() {
  var widget = document.getElementById('aussendienstWidget');
  if (!widget || widget.dataset.aussendienstInit === '1') {
    return;
  }
  var profileButton = document.getElementById('profileButton');
  var rayonWindow = document.getElementById('rayonWindow');
  var closeButton = document.getElementById('closeRayonWindow');
  if (!profileButton || !rayonWindow || !closeButton) {
    return;
  }
  widget.dataset.aussendienstInit = '1';
  var cookieName = widget.dataset.cookieName || '';
  function setOpen(isOpen) {
    profileButton.classList.toggle('is-open', isOpen);
    rayonWindow.classList.toggle('is-open', isOpen);
    profileButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }
  profileButton.addEventListener('click', function (event) {
    event.preventDefault();
    setOpen(!rayonWindow.classList.contains('is-open'));
  });
  profileButton.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      setOpen(!rayonWindow.classList.contains('is-open'));
    }
  });
  closeButton.addEventListener('click', function (event) {
    event.preventDefault();
    setOpen(false);
    if (cookieName) {
      document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    }
  });
}
window.initAussendienstPopup = initAussendienstPopup;
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAussendienstPopup);
} else {
  initAussendienstPopup();
}